/**
 * window.__fsSafePath — превратить путь ЗАПИСИ АРХИВА в сегменты, которые
 * File System Access API согласится создать на настоящем диске.
 *
 * ── Зачем ────────────────────────────────────────────────────────────────
 * `dir.getFileHandle(name,{create:true})` отвергает имя, недопустимое в
 * ФАЙЛОВОЙ СИСТЕМЕ, а не в JS. Замер /archive-extractor за 9 дней: 240 отказов
 * распаковки, из них 238 — `Failed to execute 'getFileHandle' on
 * 'FileSystemDirectoryHandle': Name is not allowed.` Это ровно то число, что и
 * общих тостов «Не удалось распаковать этот файл», то есть ГЛАВНАЯ причина
 * провала распаковки — не формат архива и не пароль, а ИМЯ файла внутри него.
 *
 * Почему именно на диске: проверено в OPFS настоящим Chrome — там
 * `a:b.txt`, `a*b.txt`, `a?b.txt`, `a<b.txt`, `a|b.txt`, `a"b.txt`, `a\b.txt`
 * создаются БЕЗ ошибки, а отвергаются только `/`, `.`, `..` и пустая строка.
 * Значит отказ в проде приходит от настоящей ФС (NTFS), которая запрещает
 * первый набор. Архивы с Linux/macOS такие имена содержат штатно.
 *
 * ── Почему не общий __outputName.sanitize ────────────────────────────────
 * Тот примитив собирает ИМЯ ВЫДАЧИ по смыслу: схлопывает пробелы, разводит
 * дефисы, срезает ведущие точки. Для распакованного файла это порча: `.gitignore`
 * стал бы `gitignore`, `my  file.txt` — `my file.txt`. Здесь нужна минимальная
 * замена: тронуть ТОЛЬКО то, что ФС не примет, и не трогать остального.
 *
 * ⚠️ Разделителем считается и `\`: ZIP, собранный на Windows, пишет
 * `dir\file.txt` одним именем, `split('/')` его не делит, и `\` попадает в имя
 * файла — снова «Name is not allowed».
 */
(function (root) {
    'use strict';

    // Запрещены в NTFS/FAT. `/` и `\` сюда не входят — они разделители и
    // обрабатываются РАНЬШЕ, разбиением пути.
    var ILLEGAL = /[<>:"|?*\u0000-\u001F]/g;
    /* Предел ДЛИНЫ сегмента — второй способ получить «Name is not allowed», и
       санитайзер его не видел. Замер 09.09.2026 на настоящей NTFS: имя в 254
       символа создаётся, в 300 — ENOENT, и то же самое для сегмента ПАПКИ.

       Берём 255 БАЙТ в UTF-8, а не 255 символов: на Windows предел — 255
       кодовых единиц UTF-16, на macOS и Linux — 255 байт. Байтовое правило
       строже обоих, поэтому имя, прошедшее здесь, примут везде; обратное — нет
       (кириллица весит вдвое, так что «255 символов» на Mac уже отказ). */
    var MAX_SEG_BYTES = 255;
    // Место под маркер усечения: «~» + 4 hex. Короткая подпись ОРИГИНАЛА, а не
    // счётчик: два длинных имени в одном архиве обрезаются в одну строку, и
    // второй файл молча затёр бы первый — create:true не спрашивает.
    var MARK_BYTES = 5;
    // Имена устройств DOS: заняты в любой папке Windows, с любым расширением.
    var RESERVED = /^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])(\.|$)/i;

    /* Считаем байты САМИ, без TextEncoder и без encodeURIComponent.
       ⚠️ encodeURIComponent БРОСАЕТ URIError на одиночном суррогате — а это
       ровно те имена, ради которых написан весь модуль: имя из архива,
       раскодированное не той кодовой страницей. Санитайзер, который сам падает
       на плохом имени, роняет распаковку целиком вместо того, чтобы её спасти.
       Одиночный суррогат кодируется как U+FFFD, то есть 3 байта, — так же, как
       это делает TextEncoder. */
    function utf8Len(str) {
        var n = 0;
        for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);
            if (c < 0x80) { n += 1; continue; }
            if (c < 0x800) { n += 2; continue; }
            if (c >= 0xD800 && c <= 0xDBFF && i + 1 < str.length) {
                var d = str.charCodeAt(i + 1);
                if (d >= 0xDC00 && d <= 0xDFFF) { n += 4; i++; continue; }
            }
            n += 3;
        }
        return n;
    }

    /* 4 hex от содержимого имени. Не крипто — «различить два имени, обрезанных
       в одну строку». Детерминирована: та же запись архива всегда даёт тот же
       файл, сколько раз ни распаковывай. */
    function shortHash(str) {
        var h = 0x811c9dc5;
        for (var i = 0; i < str.length; i++) {
            h ^= str.charCodeAt(i);
            h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
        }
        return ('000' + h.toString(16)).slice(-4);
    }

    /** Обрезать строку до max БАЙТ, не разрывая суррогатную пару. */
    function clipBytes(str, max) {
        if (utf8Len(str) <= max) return str;
        var lo = 0, hi = str.length;
        while (lo < hi) {
            var mid = (lo + hi + 1) >> 1;
            if (utf8Len(str.slice(0, mid)) <= max) lo = mid; else hi = mid - 1;
        }
        var out = str.slice(0, lo);
        var last = out.charCodeAt(out.length - 1);
        // Хвост суррогатной пары в одиночку превращается в U+FFFD.
        if (last >= 0xD800 && last <= 0xDBFF) out = out.slice(0, -1);
        return out;
    }

    /** Один сегмент → безопасный сегмент. '' — если от него ничего не осталось. */
    function segment(seg) {
        var raw = String(seg == null ? '' : seg);
        var s = raw.replace(ILLEGAL, '_');
        // Windows молча отбрасывает хвостовые точки и пробелы, из-за чего имя
        // «создалось не тем». Срезаем сами, чтобы результат был предсказуем.
        s = s.replace(/[. ]+$/, '');
        if (!s || s === '.' || s === '..') return '';
        if (RESERVED.test(s)) s = '_' + s;
        if (utf8Len(s) > MAX_SEG_BYTES) {
            // Расширение сохраняем — по нему файл открывают. Длинный «хвост
            // после точки» расширением не является, это точка внутри имени.
            var dot = s.lastIndexOf('.');
            var ext = (dot > 0 && s.length - dot <= 11) ? s.slice(dot) : '';
            var room = MAX_SEG_BYTES - MARK_BYTES - utf8Len(ext);
            if (room < 1) { ext = ''; room = MAX_SEG_BYTES - MARK_BYTES; }
            s = clipBytes(s.slice(0, dot > 0 ? dot : s.length), room) + '~' + shortHash(raw) + ext;
            s = s.replace(/[. ]+$/, '');
            if (!s) return '';
        }
        return s;
    }

    /**
     * Путь записи → { parts, name, changed }.
     * `parts` — папки, `name` — файл, `changed` — что-то пришлось поменять.
     * Если имя файла исчезло целиком, подставляем заглушку: отдать файл под
     * другим именем лучше, чем не отдать вовсе.
     */
    function safePath(path, fallbackName) {
        var raw = String(path == null ? '' : path).split(/[/\\]/).filter(Boolean);
        var out = [], changed = false;
        for (var i = 0; i < raw.length; i++) {
            var s = segment(raw[i]);
            if (s !== raw[i]) changed = true;
            if (s) out.push(s);          // '.' / '..' / пустой — просто выпадают
        }
        var name = out.pop();
        if (!name) { name = fallbackName || 'file'; changed = true; }
        return { parts: out, name: name, changed: changed };
    }

    root.__fsSafePath = { safePath: safePath, segment: segment, MAX_SEG_BYTES: MAX_SEG_BYTES };
})(typeof window !== 'undefined' ? window : this);
